import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import { ProductBoughtIcon } from "resources/svg-images/ProductBoughtIcon";
import HideIf from "util/HideIf";
import styles from "./social-proof.module.scss";

interface ISocialProofProps {
  product: ICompactProduct;
  categoryPage?: boolean;
}

function SocialProof(props: ISocialProofProps) {
  const { product, categoryPage = false } = props;
  const { t } = useTranslation("product");

  if (!product.boughtInLastMonth) {
    return null;
  }

  return (
    <div className={styles.container}>
      <ProductBoughtIcon />
      <HideIf show={categoryPage}>
        <PAText
          className={styles.social_text}
          fontSize={FONT_SIZE[0]}
          bold
        >
          {`${Number(product.boughtInLastMonth || 0).toLocaleString()}+`}
        </PAText>
      </HideIf>
      <PAText
        className={styles.social_text}
        fontSize={FONT_SIZE[0]}
      >
        {t(categoryPage ? "bought" : "social_data", { socialCount: product.boughtInLastMonth })}
      </PAText>
    </div>
  );
}

export default SocialProof;
